module.exports = __webpack_public_path__ + "static/media/pi2.93b66ad1.jpg";